export default __webpack_public_path__ + "static/media/mariachistruck.ddf6a669.jpeg";